import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import jwt_decode from "jwt-decode";
import { clearAuthToken, isTokenExpired } from "../helper/utils";
import { setUser } from "../redux/slice/auth/authSlice";

export default function AuthGuard({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const token = localStorage.getItem("auth-token");

  useEffect(() => {
    if (token && !isTokenExpired()) {
      dispatch(setUser(jwt_decode(token)));
    } else {
      clearAuthToken();
      dispatch(setUser(null));
      navigate("/");
    }
  }, [location.pathname, dispatch, navigate, token]); // listen to route changes

  return children;
}
